// @flow

import { any, includes, reject } from 'ramda'

import { CATALOG_SECTION_TYPE } from '@alphaott/app-config'

export const getContentCatalogWithoutPersonalCatalogs = reject(item =>
  any(includes(item))([CATALOG_SECTION_TYPE.RECENT, CATALOG_SECTION_TYPE.FAVORITE]),
)
